var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-like",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 30,
    height: 30,
    transform: "translate(0 0)",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M34.885,20.459v3.5a7.222,7.222,0,0,1-7.213,7.212H21.445a5.193,5.193,0,0,1-4.66-2.868L14.028,22.84a1.231,1.231,0,0,1-.132-.555V21.9h2l.33-.167.084.167h.048v.095l2.626,5.2a2.744,2.744,0,0,0,2.462,1.515h6.226a4.757,4.757,0,0,0,4.751-4.75v-3.5A4.721,4.721,0,0,0,31.035,17.1L21.171,7.219l-.472.474a2.166,2.166,0,0,0,0,3.053l2.73,2.732a1.231,1.231,0,0,1-.871,2.1l-4.776,0A1.428,1.428,0,0,0,16.358,17v2.9H13.9V17a3.89,3.89,0,0,1,3.89-3.89h1.8l-.629-.63a4.632,4.632,0,0,1-.007-6.529L20.3,4.607a1.231,1.231,0,0,1,1.743,0L32.778,15.362A7.168,7.168,0,0,1,34.885,20.459Z",
    transform: "translate(-9.161 -2.48)",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon-like.bf6d077351e1627c6023e674d6675e2e.svg";
export { ForwardRef as ReactComponent };